"use client";

import { useMemo } from "react";
import { getBreadcrumbItems } from "./utils";
import { usePathname } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";
import { APP_BASE_URL } from "@/constants/app-defaults";

const CollectionPageJsonLdComponent = ({
  collectionTypeMetaData,
  slug,
  searchParam,
  searchParams: searchParamsProp,
}: {
  collectionTypeMetaData: Record<string, unknown>;
  slug: string;
  searchParam: string;
  searchParams?: { [key: string]: string | string[] | undefined };
}) => {
  const pathname = usePathname();

  const searchParams = useMemo(() => {
    const params = new URLSearchParams();
    if (searchParamsProp) {
      Object.entries(searchParamsProp).forEach(([key, value]) => {
        if (value !== undefined) {
          params.set(key, Array.isArray(value) ? value[0] : value);
        }
      });
    }
    return params;
  }, [searchParamsProp]);

  const queryClient = useQueryClient();
  const navData = queryClient.getQueryData(["navigation"]);

  const breadcrumbItems = getBreadcrumbItems(
    pathname,
    searchParams,
    navData as unknown,
  );

  const collectionPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: collectionTypeMetaData?.meta_title,
    description: collectionTypeMetaData?.meta_description,
    url: `${APP_BASE_URL}/listing/${slug}${searchParam ? `?${searchParam}` : ""}`,
    mainEntity: {
      "@type": "ItemList",
      name: collectionTypeMetaData?.meta_title,
      description: collectionTypeMetaData?.meta_description,
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbItems,
    },
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(collectionPageJsonLd),
      }}
    />
  );
};

export default CollectionPageJsonLdComponent;
